:host {
    cursor: pointer;
}
